import { usePurchaseOrders } from "../../purchase-orders/hooks/usePurchaseOrders";
import type { SalesQueryDto } from "../../../api";

export function usePartnerPurchaseOrders(partnerId: number, query?: Omit<SalesQueryDto, "partnerId">) {
  return usePurchaseOrders({ ...query, partnerId });
}
